import { useCallback } from 'react';
import { socketService } from '@/features/messaging/api/socketService';

/**
 * Hook for typing indicators
 * 
 * @param recipientId - Recipient user ID
 */
export const useTypingIndicator = (recipientId: string | null) => {
  const sendTyping = useCallback(
    (isTyping: boolean) => {
      if (recipientId && socketService.isConnected()) {
        socketService.sendTypingIndicator(recipientId, isTyping);
      }
    },
    [recipientId]
  );

  return { sendTyping };
};

